<template src="./teamUserImportModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import surveysEndpoints from '../surveys.endpoints';

export default {
    name: 'team-user-import-modal',
    mixins: [dmModalMixin],
    data() {
        return {
            dto: {},
            sendInvitationImmediately: false,
            currentTime: null,
        }
    },
    computed: {
        lblTitle() {
          return `Import ${ this.modalData.team.Name} Users`;
        },
    },
    methods: {
        btnSaveOnClick() {
            if (this.dto.InvitationSendDateTime) {
                this.dto.InvitationSendDateTime = moment(this.dto.InvitationSendDateTime).format('M/DD/YYYY h:mm A');
            }

            surveysEndpoints.importTeamUsers(this.dto)
            	.then((response) => {
                    if (response.InvalidEmailAddresses.length > 0) {
                        DMUtils.alertShow('Unable to import email addresses: ' + response.InvalidEmailAddresses.join(', '), 'Alert');
                    } else {
                        this.successClose(this.dto);
                    }                   
            	})
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        closePreliminaryModal() {
            return new Promise((resolve) => {
                this.$store.commit('ModalModule/closeModal', this.modalID);

                return resolve();
            })
        },
        clearInvitationDate(args) {
            if (args.checked) {
                this.dto.InvitationSendDateTime = '';
            }
        }
    },
    created() {
        this.dto = DMUtils.copy(this.modalData.dto);
        
        surveysEndpoints.getTime()
            .then((response) => {
                this.currentTime = response.result;
            });
    },
}
</script>